<template>
    <component :is="roomType"></component>
</template>

<script>
    import ActiveRoom from "./ActiveRoom";
    import InactiveRoom from "./InactiveRoom";
    import Echo from "laravel-echo";

    export default {
        name: "Room",
        components: {
            ActiveRoom,
            InactiveRoom,
        },
        computed: {
            roomType() {
                return window.laravel.consultation.end_at ? 'InactiveRoom' : 'ActiveRoom';
            }
        },
        created() {
            window.echo = new Echo({
                broadcaster: 'pusher',
                key: process.env.MIX_PUSHER_APP_KEY,
                wsHost: window.laravel.sockets_host,
                wsPort: 6006,
                wssPort: 6006,
                disableStats: true,
                encrypted: true,
                enabledTransports: ['ws', 'wss']
            });
        }
    }
</script>

<style scoped>

</style>
